import zod from 'zod';

export const RootSchemas = {
    MainPage: zod.undefined(),
    ChangeLogs: zod.undefined(),
    ContactUs: zod.undefined(),
    FrequentlyAskedQuestions: zod.undefined(),
    PublicFrequentlyAskedQuestions: zod.undefined(),
    Menu: zod.undefined(),
    TermsOfUse: zod.undefined(),
    RotatePassword: zod.undefined(),
    ResetPassword: zod.object({
        token: zod.string(),
    }),
    Login: zod.undefined(),
};
